
import { defineComponent, onMounted, PropType, reactive } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'
import NewModal from '@/common/new-components/NewModal/index.vue'
import ModalPanel from '@/modules/NewDispatcher/components/ModalPanel/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'
import NewSelect from '@/ui-kit/NewSelect/index.vue'
import NewCheckbox from '@/common/new-components/NewCheckbox/index.vue'

import { TripComment } from '@/new-services/types/tms'
import PreTripDetails from '@/modules/TMSModule/components/PreTripDetails/index.vue'
import filtersGreyIcon from '@/assets/icons/filtersGrey.svg'
import { FTL } from '@/core/realisations/FTL.realisation'
import { computed } from 'vue'
import { FullFTLOrderT } from '@/core/types/orders.types'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    name: 'workplace-items',
    components: {
        Loader,
        NewButton,
        NewModal,
        PreTripDetails,
        ModalPanel,
        Cheap,
        NewSelect,
        filtersGreyIcon,
        NewCheckbox,
    },
    props: {
        ftlOrder: {
            type: Object as PropType<FullFTLOrderT>,
            default: null,
        },
        stateId: {
            type: Number,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['cancel', 'submit'],
    setup(props, { emit }) {
        const state = reactive({
            is_comments: false,
            delayCommentId: null as number | null,
        })

        const state_form$ = useVuelidate(
            {
                delayCommentId: { required },
            },
            state
        )

        const data_state = reactive({
            comments: {
                is_loading: false,
                is_failed: false,
                list: [] as TripComment[],
            },
        })

        const loadComments = async () => {
            try {
                data_state.comments.is_loading = true

                const response = await FTL.getComments(props.stateId)
                data_state.comments.list = response.data

                data_state.comments.is_failed = false
            } catch (error) {
                data_state.comments.is_failed = true
                console.error(error)
            } finally {
                data_state.comments.is_loading = false
            }
        }

        const emitCancel = () => emit('cancel')

        const emitSubmit = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('submit', state.delayCommentId)
        }

        const getTodayDate = computed(() => {
            const today = new Date()
            const dd = String(today.getDate()).padStart(2, '0')
            const mm = String(today.getMonth() + 1).padStart(2, '0')
            const yyyy = today.getFullYear()

            return `${dd}-${mm}-${yyyy}`
        })

        const getLink = computed(() => {
            if (!props.ftlOrder) return ''

            return props.ftlOrder.ftl_type === 2
                ? `/ftl-orders/intracity/${props.ftlOrder.id}`
                : `/ftl-orders/${props.ftlOrder.id}`
        })

        onMounted(() => {
            loadComments()
        })

        return {
            state,
            data_state,
            state_form$,
            getTodayDate,
            loadComments,
            emitCancel,
            emitSubmit,
            getLink,
        }
    },
})
